/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterEmotionKind = (typeof FilterEmotionKind)[keyof typeof FilterEmotionKind];

export const FilterEmotionKind = {
  emotions: 'emotions',
} as const;
